import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Image,
  InputGroup,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { MdEdit } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import Loader from "../../Components/Loader/Loader";
import { StoreInfoAPI } from "../../Utils/Api/UserProfile";
import { userId } from "../../Utils/LocalStorage";
// import StoreLocations from "../StoreLocations/StoreLocations";
import { Checkbox } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import Cropper from "react-easy-crop";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { UplaodImgWithCropper } from "../../Components/CropperImg/UplaodImgWithCropper";
import getCroppedImg from "../../Components/CropperImg/cropImage";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import DefaultImage from "../../assets/BannerEmpty.svg";
import defaultuploadBig from "../../assets/defaultbig.svg";
import iicon from "../../assets/i.svg";
import { getUploadImageFlag } from "../../redux/costHistorySlice";
import AddStoreLocation from "../StoreLocations/AddStoreLocations";
import { hours, minutes } from "./TimeArray";
import { resizeImage } from "../../Utils/ResizeUploadImg";
import { constant } from "../../Utils/Constant";

const EditNewLocationNew = () => {
  // Boolean values for dynamic representation for edit first name, last name and buttons(save,cancel)
  const [timings, setTimings] = useState({});
  const [edit, setEdit] = useState(false);
  const [storeInfo, setStoreInfo] = useState();
  const [locInfo, setLocInfo] = useState([]);

  const [UserData, setUserData] = useState({
    store_name: locInfo.store_name,
    st_website: locInfo.business_url,
    store_description: locInfo.store_description,
    appointment_status: locInfo.appointment_status,
  });
  const [isAppointment, setIsAppointment] = useState();

  const [loading, setLoading] = useState(false);

  const [daysFlag, setDaysFlag] = useState({
    sundayflag: false,
    mondayflag: false,
    tuesdayflag: false,
    wednesdayflag: false,
    thursdayflag: false,
    fridayflag: false,
    saturdayflag: false,
  });

  const [hrsInput, setHrsInput] = useState({
    sundayOpenhrs: "00",
    sundayClosehrs: "00",
    mondayOpenhrs: "00",
    mondayClosehrs: "00",
    tuesdayOpenhrs: "00",
    tuesdayClosehrs: "00",
    wednesdayOpenhrs: "00",
    wednesdayClosehrs: "00",
    thursdayOpenhrs: "00",
    thursdayClosehrs: "00",
    fridayOpenhrs: "00",
    fridayClosehrs: "00",
    saturdayOpenhrs: "00",
    saturdayClosehrs: "00",
  });

  const [minsInput, setMinsInput] = useState({
    sundayOpenMins: "00",
    sundayCloseMins: "00",
    mondayOpenMins: "00",
    mondayCloseMins: "00",
    tuesdayOpenMins: "00",
    tuesdayCloseMins: "00",
    wednesdayOpenMins: "00",
    wednesdayCloseMins: "00",
    thursdayOpenMins: "00",
    thursdayCloseMins: "00",
    fridayOpenMins: "00",
    fridayCloseMins: "00",
    saturdayOpenMins: "00",
    saturdayCloseMins: "00",
  });

  const [amPmInput, setAmPmInput] = useState({
    sundayOpenAmPm: "am",
    sundayCloseAmPm: "am",
    mondayOpenAmPm: "am",
    mondayCloseAmPm: "am",
    tuesdayOpenAmPm: "am",
    tuesdayCloseAmPm: "am",
    wednesdayOpenAmPm: "am",
    wednesdayCloseAmPm: "am",
    thursdayOpenAmPm: "am",
    thursdayCloseAmPm: "am",
    fridayOpenAmPm: "am",
    fridayCloseAmPm: "am",
    saturdayOpenAmPm: "am",
    saturdayCloseAmPm: "am",
  });

  const [editFlag, setEditFlag] = useState({
    editSundayOpenTime: false,
    editSundayCloseTime: false,
    editMondayOpenTime: false,
    editMondayCloseTime: false,
    editTuesdayOpenTime: false,
    editTuesdayCloseTime: false,
    editWednesdayOpenTime: false,
    editWednesdayCloseTime: false,
    editThursdayOpenTime: false,
    editThursdayCloseTime: false,
    editFridayOpenTime: false,
    editFridayCloseTime: false,
    editSaturdayOpenTime: false,
    editSaturdayCloseTime: false,
  });

  const [editHrsFlag, setEditHrsFlag] = useState({
    editSundayHrsOpentime: false,
    editSundayHrsClosetime: false,
    editMondayHrsOpentime: false,
    editMondayHrsClosetime: false,
    editTuesdayHrsOpentime: false,
    editTuesdayHrsClosetime: false,
    editWednesdayHrsOpentime: false,
    editWednesdayHrsClosetime: false,
    editThursdayHrsOpentime: false,
    editThursdayHrsClosetime: false,
    editFridayHrsOpentime: false,
    editFridayHrsClosetime: false,
    editSaturdayHrsOpentime: false,
    editSaturdayHrsClosetime: false,
  });

  const [editAmPmFlag, setEditAmPmFlag] = useState({
    editSundayAmPmOpentime: false,
    editSundayAmPmClosetime: false,
    editMondayAmPmOpentime: false,
    editMondayAmPmClosetime: false,
    editTuesdayAmPmOpentime: false,
    editTuesdayAmPmClosetime: false,
    editWednesdayAmPmOpentime: false,
    editWednesdayAmPmClosetime: false,
    editThursdayAmPmOpentime: false,
    editThursdayAmPmClosetime: false,
    editFridayAmPmOpentime: false,
    editFridayAmPmClosetime: false,
    editSaturdayAmPmOpentime: false,
    editSaturdayAmPmClosetime: false,
  });

  const [editMinsFlag, setEditMinsFlag] = useState({
    editSundayMinsOpentime: false,
    editSundayMinsClosetime: false,
    editMondayMinsOpentime: false,
    editMondayMinsClosetime: false,
    editTuesdayMinsOpentime: false,
    editTuesdayMinsClosetime: false,
    editWednesdayMinsOpentime: false,
    editWednesdayMinsClosetime: false,
    editThursdayMinsOpentime: false,
    editThursdayMinsClosetime: false,
    editFridayMinsOpentime: false,
    editFridayMinsClosetime: false,
    editSaturdayMinsOpentime: false,
    editSaturdayMinsClosetime: false,
  });

  //image crop
  const uploadedImage = useRef("");
  const imageUploader = useRef("");

  const [show, setShow] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(defaultuploadBig);
  const [uploadImgurl, setuploadImgurl] = useState("");
  const [imageType, setImageType] = useState("");
  const [coverImageFlag, setCoverImageFlag] = useState(false);
  const [thumbnailImageFlag, setThumbnailImageFlag] = useState(false);
  const [thumbnailImage, setThumbnailImage] = useState("");

  const [err_Displayname, setErr_Displayname] = useState("");
  const [err_Displaydesc, setErr_Displaydesc] = useState("");
  const [err_Displayweb, setErr_Displayweb] = useState("");
  const [err_DisplayImg, setErr_DisplayImg] = useState("");
  const [errBannerImg, setErrBannerImg] = useState("");
  const [errTime, setErrTime] = useState("");
  const [errdisplay, setErrDisplay] = useState({
    mondayErr: "",
    tuesdayErr: "",
    wednesdayErr: "",
    thursdayErr: "",
    fridayErr: "",
    saturdayErr: "",
    sundayErr: "",
  });

  // cropper-thumbnail-img
  const [cropImg, setcropImg] = useState("");
  const [iscropImgEdited, setIscropImgEdited] = useState(false);

  // cropper-banner-img
  // cropper-thumbnail-img
  const [cropImgBanner, setcropImgBanner] = useState("");
  const [bannerImageFlag, setbannerImageFlag] = useState(false);

  const Bu_id = userId();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let i = 0;

  const handleChange = (e) => {
    setIscropImgEdited(false);
    setUserData({
      ...UserData,
      [e.target.name]: e.target.value,
    });
  };

  const EditHandler = () => {
    setEdit(true);
    // window.scrollTo(0, 400);
  };

  const CancelHandler = () => {
    setEdit(false);
    setIscropImgEdited(false);
    setErr_Displaydesc("");
    setErr_Displayname("");
    setErr_Displayweb("");
    setEditFlag((ps) => {
      return {
        ...ps,
        editSundayOpenTime: false,
        editSundayCloseTime: false,
        editMondayOpenTime: false,
        editMondayCloseTime: false,
        editTuesdayOpenTime: false,
        editTuesdayCloseTime: false,
        editWednesdayOpenTime: false,
        editWednesdayCloseTime: false,
        editThursdayOpenTime: false,
        editThursdayCloseTime: false,
        editFridayOpenTime: false,
        editFridayCloseTime: false,
        editSaturdayOpenTime: false,
        editSaturdayCloseTime: false,
      };
    });
    getStoreInfo();
    window.scrollTo(0, 0);
  };

  ////////////////////////////////////////// 12hr Formated JASON //////////////////////////////////////////////////

  const FormatedTime12Hours = {
    sunday: {
      sundayOpenTime:
        hrsInput.sundayOpenhrs +
        ":" +
        minsInput.sundayOpenMins +
        " " +
        amPmInput.sundayOpenAmPm,
      sundayCloseTime:
        hrsInput.sundayClosehrs +
        ":" +
        minsInput.sundayCloseMins +
        " " +
        amPmInput.sundayCloseAmPm,
    },
    monday: {
      mondayOpenTime:
        hrsInput.mondayOpenhrs +
        ":" +
        minsInput.mondayOpenMins +
        " " +
        amPmInput.mondayOpenAmPm,
      mondayCloseTime:
        hrsInput.mondayClosehrs +
        ":" +
        minsInput.mondayCloseMins +
        " " +
        amPmInput.mondayCloseAmPm,
    },
    tuesday: {
      tuesdayOpenTime:
        hrsInput.tuesdayOpenhrs +
        ":" +
        minsInput.tuesdayOpenMins +
        " " +
        amPmInput.tuesdayOpenAmPm,
      tuesdayCloseTime:
        hrsInput.tuesdayClosehrs +
        ":" +
        minsInput.tuesdayCloseMins +
        " " +
        amPmInput.tuesdayCloseAmPm,
    },
    wednesday: {
      wednesdayOpenTime:
        hrsInput.wednesdayOpenhrs +
        ":" +
        minsInput.wednesdayOpenMins +
        " " +
        amPmInput.wednesdayOpenAmPm,
      wednesdayCloseTime:
        hrsInput.wednesdayClosehrs +
        ":" +
        minsInput.wednesdayCloseMins +
        " " +
        amPmInput.wednesdayCloseAmPm,
    },
    thursday: {
      thursdayOpenTime:
        hrsInput.thursdayOpenhrs +
        ":" +
        minsInput.thursdayOpenMins +
        " " +
        amPmInput.thursdayOpenAmPm,
      thursdayCloseTime:
        hrsInput.thursdayClosehrs +
        ":" +
        minsInput.thursdayCloseMins +
        " " +
        amPmInput.thursdayCloseAmPm,
    },
    friday: {
      fridayOpenTime:
        hrsInput.fridayOpenhrs +
        ":" +
        minsInput.fridayOpenMins +
        " " +
        amPmInput.fridayOpenAmPm,
      fridayCloseTime:
        hrsInput.fridayClosehrs +
        ":" +
        minsInput.fridayCloseMins +
        " " +
        amPmInput.fridayCloseAmPm,
    },
    saturday: {
      saturdayOpenTime:
        hrsInput.saturdayOpenhrs +
        ":" +
        minsInput.saturdayOpenMins +
        " " +
        amPmInput.saturdayOpenAmPm,
      saturdayCloseTime:
        hrsInput.saturdayClosehrs +
        ":" +
        minsInput.saturdayCloseMins +
        " " +
        amPmInput.saturdayCloseAmPm,
    },
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////// 24hrs API Formated JASON ////////////////////////////////////////////////

  const FormatedTime24Hours = {
    sundayOpenTime: {
      hrs: tConv24(timings?.Sunday?.opening_time).substring(0, 2),
      mins: tConv24(timings?.Sunday?.opening_time).substring(3, 5),
      ampm: tConv24(timings?.Sunday?.opening_time).substring(5, 7),
    },
    sundayCloseTime: {
      hrs: tConv24(timings?.Sunday?.closing_time).substring(0, 2),
      mins: tConv24(timings?.Sunday?.closing_time).substring(3, 5),
      ampm: tConv24(timings?.Sunday?.closing_time).substring(5, 7),
    },
    mondayOpenTime: {
      hrs: tConv24(timings?.Monday?.opening_time).substring(0, 2),
      mins: tConv24(timings?.Monday?.opening_time).substring(3, 5),
      ampm: tConv24(timings?.Monday?.opening_time).substring(5, 7),
    },
    mondayCloseTime: {
      hrs: tConv24(timings?.Monday?.closing_time).substring(0, 2),
      mins: tConv24(timings?.Monday?.closing_time).substring(3, 5),
      ampm: tConv24(timings?.Monday?.closing_time).substring(5, 7),
    },
    tuesdayOpenTime: {
      hrs: tConv24(timings?.Tuesday?.opening_time).substring(0, 2),
      mins: tConv24(timings?.Tuesday?.opening_time).substring(3, 5),
      ampm: tConv24(timings?.Tuesday?.opening_time).substring(5, 7),
    },
    tuesdayCloseTime: {
      hrs: tConv24(timings?.Tuesday?.closing_time).substring(0, 2),
      mins: tConv24(timings?.Tuesday?.closing_time).substring(3, 5),
      ampm: tConv24(timings?.Tuesday?.closing_time).substring(5, 7),
    },
    wednesdayOpenTime: {
      hrs: tConv24(timings?.Wednesday?.opening_time).substring(0, 2),
      mins: tConv24(timings?.Wednesday?.opening_time).substring(3, 5),
      ampm: tConv24(timings?.Wednesday?.opening_time).substring(5, 7),
    },
    wednesdayCloseTime: {
      hrs: tConv24(timings?.Wednesday?.closing_time).substring(0, 2),
      mins: tConv24(timings?.Wednesday?.closing_time).substring(3, 5),
      ampm: tConv24(timings?.Wednesday?.closing_time).substring(5, 7),
    },
    thursdayOpenTime: {
      hrs: tConv24(timings?.Thursday?.opening_time).substring(0, 2),
      mins: tConv24(timings?.Thursday?.opening_time).substring(3, 5),
      ampm: tConv24(timings?.Thursday?.opening_time).substring(5, 7),
    },
    thursdayCloseTime: {
      hrs: tConv24(timings?.Thursday?.closing_time).substring(0, 2),
      mins: tConv24(timings?.Thursday?.closing_time).substring(3, 5),
      ampm: tConv24(timings?.Thursday?.closing_time).substring(5, 7),
    },
    fridayOpenTime: {
      hrs: tConv24(timings?.Friday?.opening_time).substring(0, 2),
      mins: tConv24(timings?.Friday?.opening_time).substring(3, 5),
      ampm: tConv24(timings?.Friday?.opening_time).substring(5, 7),
    },
    fridayCloseTime: {
      hrs: tConv24(timings?.Friday?.closing_time).substring(0, 2),
      mins: tConv24(timings?.Friday?.closing_time).substring(3, 5),
      ampm: tConv24(timings?.Friday?.closing_time).substring(5, 7),
    },
    saturdayOpenTime: {
      hrs: tConv24(timings?.Saturday?.opening_time).substring(0, 2),
      mins: tConv24(timings?.Saturday?.opening_time).substring(3, 5),
      ampm: tConv24(timings?.Saturday?.opening_time).substring(5, 7),
    },
    saturdayCloseTime: {
      hrs: tConv24(timings?.Saturday?.closing_time).substring(0, 2),
      mins: tConv24(timings?.Saturday?.closing_time).substring(3, 5),
      ampm: tConv24(timings?.Saturday?.closing_time).substring(5, 7),
    },
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  ///////////////////////////////////////// convert fuction from 24 to 12 Hours Format ///////////////////////////////

  function tConv24(timeString) {
    let hours = parseInt(timeString?.substr(0, 2));
    const minutes = timeString?.substr(3, 2);
    let ampm = "am";
    if (hours >= 12) {
      ampm = "pm";
      hours = hours - 12;
    }
    if (hours === 0) {
      hours = 12;
    }
    let sHours = hours.toString();
    sHours = sHours.length === 1 ? "0" + sHours : sHours;
    return `${sHours}:${minutes}${ampm}`;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////// convert fuction from 12 to 24 Hours Format ///////////////////////////////

  function convertTime12To24(timeString) {
    let hours = parseInt(timeString.substr(0, 2));
    const minutes = timeString.substr(3, 2);
    const ampm = timeString.substr(6, 2);
    if (ampm === "pm" && hours < 12) {
      hours = hours + 12;
    }
    if (ampm === "am" && hours === 12) {
      hours = hours - 12;
    }

    let sHours = hours.toString();
    sHours = sHours.length === 1 ? "0" + sHours : sHours;

    return `${sHours}:${minutes}`;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////// Sunday form func //////////////////////////////////////////////////

  const handleSwitchSunday = (e) => {
    let val = e.target.checked;
    setDaysFlag((ps) => {
      return { ...ps, sundayflag: val };
    });
    setErrDisplay((ps) => {
      return { ...ps, sundayErr: "" };
    });
  };

  const onSunday = (flag, e) => {
    let val = e.target.value;

    setEditFlag((ps) => {
      return { ...ps, editSundayOpenTime: true };
    });

    if (flag === "hrs") {
      setEditHrsFlag((ps) => {
        return { ...ps, editSundayHrsOpentime: true };
      });
      setHrsInput((ps) => {
        return { ...ps, sundayOpenhrs: val };
      });
    }
    if (flag === "mins") {
      setEditMinsFlag((ps) => {
        return { ...ps, editSundayMinsOpentime: true };
      });
      setMinsInput((ps) => {
        return { ...ps, sundayOpenMins: val };
      });
    }
    if (flag === "ampm") {
      setEditAmPmFlag((ps) => {
        return { ...ps, editSundayAmPmOpentime: true };
      });
      setAmPmInput((ps) => {
        return { ...ps, sundayOpenAmPm: val };
      });
    }
  };

  const offSunday = (flag, e) => {
    let val = e.target.value;

    setEditFlag((ps) => {
      return { ...ps, editSundayCloseTime: true };
    });

    if (flag === "hrs") {
      setEditHrsFlag((ps) => {
        return { ...ps, editSundayHrsClosetime: true };
      });
      setHrsInput((ps) => {
        return { ...ps, sundayClosehrs: val };
      });
    }
    if (flag === "mins") {
      setEditMinsFlag((ps) => {
        return { ...ps, editSundayMinsClosetime: true };
      });
      setMinsInput((ps) => {
        return { ...ps, sundayCloseMins: val };
      });
    }
    if (flag === "ampm") {
      setEditAmPmFlag((ps) => {
        return { ...ps, editSundayAmPmClosetime: true };
      });
      setAmPmInput((ps) => {
        return { ...ps, sundayCloseAmPm: val };
      });
    }
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////// Monday form func /////////////////////////////////////////////

  const handleSwitchMonday = (e) => {
    let val = e.target.checked;
    setDaysFlag((ps) => {
      return { ...ps, mondayflag: val };
    });
    setErrDisplay((ps) => {
      return { ...ps, mondayErr: "" };
    });
  };

  const onMonday = (flag, e) => {
    let val = e.target.value;

    setEditFlag((ps) => {
      return { ...ps, editMondayOpenTime: true };
    });

    if (flag === "hrs") {
      setEditHrsFlag((ps) => {
        return { ...ps, editMondayHrsOpentime: true };
      });
      setHrsInput((ps) => {
        return { ...ps, mondayOpenhrs: val };
      });
    }
    if (flag === "mins") {
      setEditMinsFlag((ps) => {
        return { ...ps, editMondayMinsOpentime: true };
      });
      setMinsInput((ps) => {
        return { ...ps, mondayOpenMins: val };
      });
    }
    if (flag === "ampm") {
      setEditAmPmFlag((ps) => {
        return { ...ps, editMondayAmPmOpentime: true };
      });
      setAmPmInput((ps) => {
        return { ...ps, mondayOpenAmPm: val };
      });
    }
  };

  const offMonday = (flag, e) => {
    let val = e.target.value;

    setEditFlag((ps) => {
      return { ...ps, editMondayCloseTime: true };
    });

    if (flag === "hrs") {
      setEditHrsFlag((ps) => {
        return { ...ps, editMondayHrsClosetime: true };
      });
      setHrsInput((ps) => {
        return { ...ps, mondayClosehrs: val };
      });
    }
    if (flag === "mins") {
      setEditMinsFlag((ps) => {
        return { ...ps, editMondayMinsClosetime: true };
      });
      setMinsInput((ps) => {
        return { ...ps, mondayCloseMins: val };
      });
    }
    if (flag === "ampm") {
      setEditAmPmFlag((ps) => {
        return { ...ps, editMondayAmPmClosetime: true };
      });
      setAmPmInput((ps) => {
        return { ...ps, mondayCloseAmPm: val };
      });
    }
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////// Tuesday form func ////////////////////////////////////////////

  const handleSwitchTuesday = (e) => {
    let val = e.target.checked;
    setDaysFlag((ps) => {
      return { ...ps, tuesdayflag: val };
    });
    setErrDisplay((ps) => {
      return { ...ps, tuesdayErr: "" };
    });
  };

  const onTuesday = (flag, e) => {
    let val = e.target.value;

    setEditFlag((ps) => {
      return { ...ps, editTuesdayOpenTime: true };
    });

    if (flag === "hrs") {
      setEditHrsFlag((ps) => {
        return { ...ps, editTuesdayHrsOpentime: true };
      });
      setHrsInput((ps) => {
        return { ...ps, tuesdayOpenhrs: val };
      });
    }
    if (flag === "mins") {
      setEditMinsFlag((ps) => {
        return { ...ps, editTuesdayMinsOpentime: true };
      });
      setMinsInput((ps) => {
        return { ...ps, tuesdayOpenMins: val };
      });
    }
    if (flag === "ampm") {
      setEditAmPmFlag((ps) => {
        return { ...ps, editTuesdayAmPmOpentime: true };
      });
      setAmPmInput((ps) => {
        return { ...ps, tuesdayOpenAmPm: val };
      });
    }
  };

  const offTuesday = (flag, e) => {
    let val = e.target.value;

    setEditFlag((ps) => {
      return { ...ps, editTuesdayCloseTime: true };
    });

    if (flag === "hrs") {
      setEditHrsFlag((ps) => {
        return { ...ps, editTuesdayHrsClosetime: true };
      });
      setHrsInput((ps) => {
        return { ...ps, tuesdayClosehrs: val };
      });
    }
    if (flag === "mins") {
      setEditMinsFlag((ps) => {
        return { ...ps, editTuesdayMinsClosetime: true };
      });
      setMinsInput((ps) => {
        return { ...ps, tuesdayCloseMins: val };
      });
    }
    if (flag === "ampm") {
      setEditAmPmFlag((ps) => {
        return { ...ps, editTuesdayAmPmClosetime: true };
      });
      setAmPmInput((ps) => {
        return { ...ps, tuesdayCloseAmPm: val };
      });
    }
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////

  //////////////////////////////////////////// Wednesday form func ///////////////////////////////////////////

  const handleSwitchWednesday = (e) => {
    let val = e.target.checked;
    setDaysFlag((ps) => {
      return { ...ps, wednesdayflag: val };
    });
    setErrDisplay((ps) => {
      return { ...ps, wednesdayErr: "" };
    });
  };

  const onWednesday = (flag, e) => {
    let val = e.target.value;

    setEditFlag((ps) => {
      return { ...ps, editWednesdayOpenTime: true };
    });

    if (flag === "hrs") {
      setEditHrsFlag((ps) => {
        return { ...ps, editWednesdayHrsOpentime: true };
      });
      setHrsInput((ps) => {
        return { ...ps, wednesdayOpenhrs: val };
      });
    }
    if (flag === "mins") {
      setEditMinsFlag((ps) => {
        return { ...ps, editWednesdayMinsOpentime: true };
      });
      setMinsInput((ps) => {
        return { ...ps, wednesdayOpenMins: val };
      });
    }
    if (flag === "ampm") {
      setEditAmPmFlag((ps) => {
        return { ...ps, editWednesdayAmPmOpentime: true };
      });
      setAmPmInput((ps) => {
        return { ...ps, wednesdayOpenAmPm: val };
      });
    }
  };

  const offWednesday = (flag, e) => {
    let val = e.target.value;

    setEditFlag((ps) => {
      return { ...ps, editWednesdayCloseTime: true };
    });

    if (flag === "hrs") {
      setEditHrsFlag((ps) => {
        return { ...ps, editWednesdayHrsClosetime: true };
      });
      setHrsInput((ps) => {
        return { ...ps, wednesdayClosehrs: val };
      });
    }
    if (flag === "mins") {
      setEditMinsFlag((ps) => {
        return { ...ps, editWednesdayMinsClosetime: true };
      });
      setMinsInput((ps) => {
        return { ...ps, wednesdayCloseMins: val };
      });
    }
    if (flag === "ampm") {
      setEditAmPmFlag((ps) => {
        return { ...ps, editWednesdayAmPmClosetime: true };
      });
      setAmPmInput((ps) => {
        return { ...ps, wednesdayCloseAmPm: val };
      });
    }
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////

  /////////////////////////////////////////// Thursday form func /////////////////////////////////////////////

  const handleSwitchThursday = (e) => {
    let val = e.target.checked;
    setDaysFlag((ps) => {
      return { ...ps, thursdayflag: val };
    });
    setErrDisplay((ps) => {
      return { ...ps, thursdayErr: "" };
    });
  };

  const onThursday = (flag, e) => {
    let val = e.target.value;

    setEditFlag((ps) => {
      return { ...ps, editThursdayOpenTime: true };
    });

    if (flag === "hrs") {
      setEditHrsFlag((ps) => {
        return { ...ps, editThursdayHrsOpentime: true };
      });
      setHrsInput((ps) => {
        return { ...ps, thursdayOpenhrs: val };
      });
    }
    if (flag === "mins") {
      setEditMinsFlag((ps) => {
        return { ...ps, editThursdayMinsOpentime: true };
      });
      setMinsInput((ps) => {
        return { ...ps, thursdayOpenMins: val };
      });
    }
    if (flag === "ampm") {
      setEditAmPmFlag((ps) => {
        return { ...ps, editThursdayAmPmOpentime: true };
      });
      setAmPmInput((ps) => {
        return { ...ps, thursdayOpenAmPm: val };
      });
    }
  };

  const offThursday = (flag, e) => {
    let val = e.target.value;

    setEditFlag((ps) => {
      return { ...ps, editThursdayCloseTime: true };
    });

    if (flag === "hrs") {
      setEditHrsFlag((ps) => {
        return { ...ps, editThursdayHrsClosetime: true };
      });
      setHrsInput((ps) => {
        return { ...ps, thursdayClosehrs: val };
      });
    }
    if (flag === "mins") {
      setEditMinsFlag((ps) => {
        return { ...ps, editThursdayMinsClosetime: true };
      });
      setMinsInput((ps) => {
        return { ...ps, thursdayCloseMins: val };
      });
    }
    if (flag === "ampm") {
      setEditAmPmFlag((ps) => {
        return { ...ps, editThursdayAmPmClosetime: true };
      });
      setAmPmInput((ps) => {
        return { ...ps, thursdayCloseAmPm: val };
      });
    }
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////// Friday form func ////////////////////////////////////////////////

  const handleSwitchFriday = (e) => {
    let val = e.target.checked;
    setDaysFlag((ps) => {
      return { ...ps, fridayflag: val };
    });
    setErrDisplay((ps) => {
      return { ...ps, fridayErr: "" };
    });
  };

  const onFriday = (flag, e) => {
    let val = e.target.value;

    setEditFlag((ps) => {
      return { ...ps, editFridayOpenTime: true };
    });

    if (flag === "hrs") {
      setEditHrsFlag((ps) => {
        return { ...ps, editFridayHrsOpentime: true };
      });
      setHrsInput((ps) => {
        return { ...ps, fridayOpenhrs: val };
      });
    }
    if (flag === "mins") {
      setEditMinsFlag((ps) => {
        return { ...ps, editFridayMinsOpentime: true };
      });
      setMinsInput((ps) => {
        return { ...ps, fridayOpenMins: val };
      });
    }
    if (flag === "ampm") {
      setEditAmPmFlag((ps) => {
        return { ...ps, editFridayAmPmOpentime: true };
      });
      setAmPmInput((ps) => {
        return { ...ps, fridayOpenAmPm: val };
      });
    }
  };

  const offFriday = (flag, e) => {
    let val = e.target.value;

    setEditFlag((ps) => {
      return { ...ps, editFridayCloseTime: true };
    });

    if (flag === "hrs") {
      setEditHrsFlag((ps) => {
        return { ...ps, editFridayHrsClosetime: true };
      });
      setHrsInput((ps) => {
        return { ...ps, fridayClosehrs: val };
      });
    }
    if (flag === "mins") {
      setEditMinsFlag((ps) => {
        return { ...ps, editFridayMinsClosetime: true };
      });
      setMinsInput((ps) => {
        return { ...ps, fridayCloseMins: val };
      });
    }
    if (flag === "ampm") {
      setEditAmPmFlag((ps) => {
        return { ...ps, editFridayAmPmClosetime: true };
      });
      setAmPmInput((ps) => {
        return { ...ps, fridayCloseAmPm: val };
      });
    }
  };

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////// Saturday form func /////////////////////////////////////////////

  const handleSwitchSaturday = (e) => {
    let val = e.target.checked;
    setDaysFlag((ps) => {
      return { ...ps, saturdayflag: val };
    });
    setErrDisplay((ps) => {
      return { ...ps, saturdayErr: "" };
    });
  };

  const onSaturday = (flag, e) => {
    let val = e.target.value;

    setEditFlag((ps) => {
      return { ...ps, editSaturdayOpenTime: true };
    });

    if (flag === "hrs") {
      setEditHrsFlag((ps) => {
        return { ...ps, editSaturdayHrsOpentime: true };
      });
      setHrsInput((ps) => {
        return { ...ps, saturdayOpenhrs: val };
      });
    }
    if (flag === "mins") {
      setEditMinsFlag((ps) => {
        return { ...ps, editSaturdayMinsOpentime: true };
      });
      setMinsInput((ps) => {
        return { ...ps, saturdayOpenMins: val };
      });
    }
    if (flag === "ampm") {
      setEditAmPmFlag((ps) => {
        return { ...ps, editSaturdayAmPmOpentime: true };
      });
      setAmPmInput((ps) => {
        return { ...ps, saturdayOpenAmPm: val };
      });
    }
  };

  const offSaturday = (flag, e) => {
    let val = e.target.value;

    setEditFlag((ps) => {
      return { ...ps, editSaturdayCloseTime: true };
    });

    if (flag === "hrs") {
      setEditHrsFlag((ps) => {
        return { ...ps, editSaturdayHrsClosetime: true };
      });
      setHrsInput((ps) => {
        return { ...ps, saturdayClosehrs: val };
      });
    }
    if (flag === "mins") {
      setEditMinsFlag((ps) => {
        return { ...ps, editSaturdayMinsClosetime: true };
      });
      setMinsInput((ps) => {
        return { ...ps, saturdayCloseMins: val };
      });
    }
    if (flag === "ampm") {
      setEditAmPmFlag((ps) => {
        return { ...ps, editSaturdayAmPmClosetime: true };
      });
      setAmPmInput((ps) => {
        return { ...ps, saturdayCloseAmPm: val };
      });
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  const handleSubmit = (event) => {
    event.preventDefault();
    handleAddStore();
  };

  /////////////////////////////////// image cropper fuction ////////////////////////////////////////////

  //upload

  const fileTypes = ["JPEG", "PNG", "GIF"];

  const [file, setFile] = useState(null);
  // const handleChange = (file) => {
  //   setFile(file);
  // };

  //image upload
  const [imageSrc, setImageSrc] = useState("");
  const [prevImg, setPrevimg] = useState("");

  const handleImageUpload = (e) => {
    // e.preventDefault();
    setShow(true);
    setPrevimg(URL.createObjectURL(e.target.files[0]));
    // const [file] = e.target.files;
    // if (file) {
    //   const reader = new FileReader();
    //   const { current } = uploadedImage;
    //   current.file = file;
    //   reader.onload = (e) => {
    //     current.src = e.target.result;
    //     setuploadImgurl(current.src);
    //     console.log(uploadedImage.current.file.name, current.src);
    //   };
    //   reader.readAsDataURL(file);
    //   //reader.readAsBinaryString(file);
    //   setShow(true);
    // }
    // setImgErr("");
  };

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        prevImg,
        croppedAreaPixels,
        rotation
      );
      setcropImgBanner(croppedImage);

      let typeImg = croppedImage.split("/");
      let imageTypeSplit = typeImg[1].split(";");

      setImageType(imageTypeSplit[0]);
      setShow(false);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  const onClose = useCallback(() => {
    setCroppedImage(null);
  }, []);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleImageSelect = (e) => {
    setImageSrc(URL.createObjectURL(e.target.files[0]));
  };

  const uploadFiles = () => {
    document.getElementById("selectFile").click();
  };

  ///////////////////////////////////////////////////////////////////////////////////////////////////////

  const getStoreInfo = async () => {
    const t = {
      bu_id: Bu_id,
      api_method: "get",
    };
    setLoading(true);
    const g = await StoreInfoAPI(t, () => {
      navigate("/");
    });
    if (g === false) {
      setLoading(false);
    } else {
      if (g.success === true) {
        const list = g?.Data[0];
        const times = list.store_timings;
        setLocInfo(list);
        setTimings(times);
        setIsAppointment(list?.appointment_status === "False" ? false : true);
        setCroppedImage(list.store_image ? list.store_image : "");
        setUserData({
          // store_name: list.store_name,
          st_website: list.business_url,
          // store_description: list.store_description,
        });
        setcropImg(list.store_thumbnail);
        setThumbnailImage(list.store_thumbnail);

        // banner
        setcropImgBanner(list.store_image);
        setLoading(false);

        // Set state back process

        if (Object.keys(times).length !== 0) {
          const convertTime = (timeStr) => {
            if (timeStr === "00:00:00") {
              return "Closed";
            }

            const [hours, minutes] = timeStr.split(":");
            const hour = parseInt(hours);
            const minute = parseInt(minutes);
            const ampm = hour >= 12 ? "pm" : "am";
            const hour12 = hour > 12 ? hour - 12 : hour;

            return `${hour12}:${minutes} ${ampm}`;
          };

          const sliceTime = (timeStr) => {
            if (timeStr === "Closed") {
              return { hours: "Closed", minutes: "", ampm: "" };
            }

            const [time, ampm] = timeStr.split(" ");
            const [hours, minutes] = time.split(":");
            const hour12 = parseInt(hours);
            const minute = parseInt(minutes);

            // Add leading zeros to hours and minutes
            const formattedHours = hour12 < 10 ? `0${hour12}` : `${hour12}`;
            const formattedMinutes = minute < 10 ? `0${minute}` : `${minute}`;

            return { hours: formattedHours, minutes: formattedMinutes, ampm };
          };

          const convertedData = {};
          for (const day in times ? times : {}) {
            const { opening_time, closing_time, store_closed } = times[day];
            const convertedOpeningTime = convertTime(opening_time);
            const convertedClosingTime = convertTime(closing_time);
            convertedData[day] = {
              opening_time: convertedOpeningTime,
              closing_time: convertedClosingTime,
              store_closed,
              slicedOpeningTime: sliceTime(convertedOpeningTime),
              slicedClosingTime: sliceTime(convertedClosingTime),
            };

            // Saturday

            if (
              (await convertedData?.Saturday?.slicedClosingTime?.hours) !==
              "Closed"
            ) {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  saturdayClosehrs:
                    convertedData?.Saturday?.slicedClosingTime?.hours,
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  saturdayCloseMins:
                    convertedData?.Saturday?.slicedClosingTime?.minutes,
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  saturdayCloseAmPm:
                    convertedData?.Saturday?.slicedClosingTime?.ampm,
                };
              });
            } else {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  saturdayClosehrs: "12",
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  saturdayCloseMins: "00",
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  saturdayCloseAmPm: "am",
                };
              });
            }

            if (
              (await convertedData?.Saturday?.slicedOpeningTime?.hours) !==
              "Closed"
            ) {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  saturdayOpenhrs:
                    convertedData?.Saturday?.slicedOpeningTime?.hours,
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  saturdayOpenMins:
                    convertedData?.Saturday?.slicedOpeningTime?.minutes,
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  saturdayOpenAmPm:
                    convertedData?.Saturday?.slicedOpeningTime?.ampm,
                };
              });
            } else {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  saturdayOpenhrs: "12",
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  saturdayOpenMins: "00",
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  saturdayOpenAmPm: "am",
                };
              });
            }

            // Sunday

            if (
              (await convertedData?.Sunday?.slicedClosingTime?.hours) !==
              "Closed"
            ) {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  sundayClosehrsClosehrs:
                    convertedData?.Sunday?.slicedClosingTime?.hours,
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  sundayCloseMins:
                    convertedData?.Sunday?.slicedClosingTime?.minutes,
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  sundayCloseAmPm:
                    convertedData?.Sunday?.slicedClosingTime?.ampm,
                };
              });
            } else {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  sundayClosehrsClosehrs: "12",
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  sundayCloseMins: "00",
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  sundayCloseAmPm: "am",
                };
              });
            }

            if (
              (await convertedData?.Sunday?.slicedOpeningTime?.hours) !==
              "Closed"
            ) {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  sundayOpenhrs:
                    convertedData?.Sunday?.slicedOpeningTime?.hours,
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  sundayOpenMins:
                    convertedData?.Sunday?.slicedOpeningTime?.minutes,
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  sundayOpenAmPm:
                    convertedData?.Sunday?.slicedOpeningTime?.ampm,
                };
              });
            } else {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  sundayOpenhrs: "12",
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  sundayOpenMins: "00",
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  sundayOpenAmPm: "am",
                };
              });
            }

            // Friday

            if (
              (await convertedData?.Friday?.slicedClosingTime?.hours) !==
              "Closed"
            ) {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  fridayClosehrs:
                    convertedData?.Friday?.slicedClosingTime?.hours,
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  fridayCloseMins:
                    convertedData?.Friday?.slicedClosingTime?.minutes,
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  fridayCloseAmPm:
                    convertedData?.Friday?.slicedClosingTime?.ampm,
                };
              });
            } else {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  fridayClosehrs: "12",
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  fridayCloseMins: "00",
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  fridayCloseAmPm: "am",
                };
              });
            }

            if (
              (await convertedData?.Friday?.slicedOpeningTime?.hours) !==
              "Closed"
            ) {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  fridayOpenhrs:
                    convertedData?.Friday?.slicedOpeningTime?.hours,
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  fridayOpenMins:
                    convertedData?.Friday?.slicedOpeningTime?.minutes,
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  fridayOpenAmPm:
                    convertedData?.Friday?.slicedOpeningTime?.ampm,
                };
              });
            } else {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  fridayOpenhrs: "12",
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  fridayOpenMins: "00",
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  fridayOpenAmPm: "am",
                };
              });
            }

            // Thursday

            if (
              (await convertedData?.Thursday?.slicedClosingTime?.hours) !==
              "Closed"
            ) {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  thursdayClosehrs:
                    convertedData?.Thursday?.slicedClosingTime?.hours,
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  thursdayCloseMins:
                    convertedData?.Thursday?.slicedClosingTime?.minutes,
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  thursdayCloseAmPm:
                    convertedData?.Thursday?.slicedClosingTime?.ampm,
                };
              });
            } else {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  thursdayClosehrs: "12",
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  thursdayCloseMins: "00",
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  thursdayCloseAmPm: "am",
                };
              });
            }

            if (
              (await convertedData?.Thursday?.slicedOpeningTime?.hours) !==
              "Closed"
            ) {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  thursdayOpenhrs:
                    convertedData?.Thursday?.slicedOpeningTime?.hours,
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  thursdayOpenMins:
                    convertedData?.Thursday?.slicedOpeningTime?.minutes,
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  thursdayOpenAmPm:
                    convertedData?.Thursday?.slicedOpeningTime?.ampm,
                };
              });
            } else {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  thursdayOpenhrs: "12",
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  thursdayOpenMins: "00",
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  thursdayOpenAmPm: "am",
                };
              });
            }

            // Wednesday

            if (
              (await convertedData?.Wednesday?.slicedClosingTime?.hours) !==
              "Closed"
            ) {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  wednesdayClosehrs:
                    convertedData?.Wednesday?.slicedClosingTime?.hours,
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  wednesdayCloseMins:
                    convertedData?.Wednesday?.slicedClosingTime?.minutes,
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  wednesdayCloseAmPm:
                    convertedData?.Wednesday?.slicedClosingTime?.ampm,
                };
              });
            } else {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  wednesdayClosehrs: "12",
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  wednesdayCloseMins: "00",
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  wednesdayCloseAmPm: "am",
                };
              });
            }

            if (
              (await convertedData?.Wednesday?.slicedOpeningTime?.hours) !==
              "Closed"
            ) {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  wednesdayOpenhrs:
                    convertedData?.Wednesday?.slicedOpeningTime?.hours,
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  wednesdayOpenMins:
                    convertedData?.Wednesday?.slicedOpeningTime?.minutes,
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  wednesdayOpenAmPm:
                    convertedData?.Wednesday?.slicedOpeningTime?.ampm,
                };
              });
            } else {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  wednesdayOpenhrs: "12",
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  wednesdayOpenMins: "00",
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  wednesdayOpenAmPm: "am",
                };
              });
            }

            // Tuesday

            if (
              (await convertedData?.Tuesday?.slicedClosingTime?.hours) !==
              "Closed"
            ) {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  tuesdayClosehrs:
                    convertedData?.Tuesday?.slicedClosingTime?.hours,
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  tuesdayCloseMins:
                    convertedData?.Tuesday?.slicedClosingTime?.minutes,
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  tuesdayCloseAmPm:
                    convertedData?.Tuesday?.slicedClosingTime?.ampm,
                };
              });
            } else {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  tuesdayClosehrs: "12",
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  tuesdayCloseMins: "00",
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  tuesdayCloseAmPm: "am",
                };
              });
            }

            if (
              (await convertedData?.Tuesday?.slicedOpeningTime?.hours) !==
              "Closed"
            ) {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  tuesdayOpenhrs:
                    convertedData?.Tuesday?.slicedOpeningTime?.hours,
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  tuesdayOpenMins:
                    convertedData?.Tuesday?.slicedOpeningTime?.minutes,
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  tuesdayOpenAmPm:
                    convertedData?.Tuesday?.slicedOpeningTime?.ampm,
                };
              });
            } else {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  tuesdayOpenhrs: "12",
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  tuesdayOpenMins: "00",
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  tuesdayOpenAmPm: "am",
                };
              });
            }

            // Monday

            if (
              (await convertedData?.Monday?.slicedClosingTime?.hours) !==
              "Closed"
            ) {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  mondayClosehrs:
                    convertedData?.Monday?.slicedClosingTime?.hours,
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  mondayCloseMins:
                    convertedData?.Monday?.slicedClosingTime?.minutes,
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  mondayCloseAmPm:
                    convertedData?.Monday?.slicedClosingTime?.ampm,
                };
              });
            } else {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  mondayClosehrs: "12",
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  mondayCloseMins: "00",
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  mondayCloseAmPm: "am",
                };
              });
            }

            if (
              (await convertedData?.Monday?.slicedOpeningTime?.hours) !==
              "Closed"
            ) {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  mondayOpenhrs:
                    convertedData?.Monday?.slicedOpeningTime?.hours,
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  mondayOpenMins:
                    convertedData?.Monday?.slicedOpeningTime?.minutes,
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  mondayOpenAmPm:
                    convertedData?.Monday?.slicedOpeningTime?.ampm,
                };
              });
            } else {
              setHrsInput((ps) => {
                return {
                  ...ps,
                  mondayOpenhrs: "12",
                };
              });
              setMinsInput((ps) => {
                return {
                  ...ps,
                  mondayOpenMins: "00",
                };
              });
              setAmPmInput((ps) => {
                return {
                  ...ps,
                  mondayOpenAmPm: "am",
                };
              });
            }
          }
        }

        //

        if (times?.Sunday?.store_closed === true) {
          setDaysFlag((ps) => {
            return {
              ...ps,
              sundayflag: true,
            };
          });
        }

        if (times?.Monday?.store_closed === true) {
          setDaysFlag((ps) => {
            return {
              ...ps,
              mondayflag: true,
            };
          });
        }

        if (times?.Tuesday?.store_closed === true) {
          setDaysFlag((ps) => {
            return {
              ...ps,
              tuesdayflag: true,
            };
          });
        }

        if (times?.Wednesday?.store_closed === true) {
          setDaysFlag((ps) => {
            return {
              ...ps,
              wednesdayflag: true,
            };
          });
        }

        if (times?.Thursday?.store_closed === true) {
          setDaysFlag((ps) => {
            return {
              ...ps,
              thursdayflag: true,
            };
          });
        }

        if (times?.Friday?.store_closed === true) {
          setDaysFlag((ps) => {
            return {
              ...ps,
              fridayflag: true,
            };
          });
        }

        if (times?.Saturday?.store_closed === true) {
          setDaysFlag((ps) => {
            return {
              ...ps,
              saturdayflag: true,
            };
          });
        }

        setLoading(false);
      } else if (g.status === 429) {
        setLoading(true);
        toast.error(g.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        setDaysFlag(() => {
          return {
            sundayflag: true,
            saturdayflag: true,
            fridayflag: true,
            thursdayflag: true,
            wednesdayflag: true,
            tuesdayflag: true,
            mondayflag: true,
          };
        });
        setLoading(false);
      }
    }
  };

  // console.log(FormatedTime12Hours.saturday.saturdayCloseTime, "On change");

  // console.log(FormatedTime24Hours.saturdayCloseTime.ampm, "Incoming change");

  // console.log(FormatedTime24Hours?.saturdayCloseTime?.hrs, "Incoming hrs");

  // console.log(FormatedTime12Hours.monday.mondayOpenTime, "hfjhhhjf");

  const handleAddStore = () => {
    let flag = false;

    dispatch(getUploadImageFlag(false));
    ////////////////////////////////// thumbnail image var ////////////////////////////////////////////
    const Cropped = cropImg?.split("/");
    const ImagePath = Cropped[3] + "/" + Cropped[4] + "/" + Cropped[5];
    const FileTypeArr = Cropped[1] ? Cropped[1].split(";") : "";
    const FileyType = FileTypeArr[0];

    const ThumbnailImgSplit = thumbnailImage?.split("/");
    const ThumbnailImgPath =
      ThumbnailImgSplit[3] +
      "/" +
      ThumbnailImgSplit[4] +
      "/" +
      ThumbnailImgSplit[5];
    ///////////////////////////////////////////////////////////////////////////////////////////////////

    //  banner-img
    const CoverImageSplit = locInfo.store_image
      ? locInfo?.store_image?.split("/")
      : "";
    const CoverImagePath = CoverImageSplit
      ? CoverImageSplit[3] + "/" + CoverImageSplit[4] + "/" + CoverImageSplit[5]
      : "";
    //////////////////////////////////////////////////////////////////////////////////////////////////

    const data = {
      appointment_status: isAppointment,
      store_thumbnail_change:
        edit === true && thumbnailImageFlag == true ? 1 : 0,
      store_thumbnail:
        edit === true && thumbnailImageFlag == true
          ? { data: cropImg, file_type: "png" }
          : ThumbnailImgPath,
      // banner

      store_image:
        edit === true && bannerImageFlag == true
          ? { data: cropImgBanner, file_type: "png" }
          : CoverImagePath,
      store_image_change: edit === true && bannerImageFlag == true ? 1 : 0,

      store_name: UserData.store_name,
      st_website: UserData.st_website,
      store_description: UserData.store_description,
      monday_o:
        daysFlag.mondayflag === true
          ? ""
          : editFlag.editMondayOpenTime === true
          ? convertTime12To24(FormatedTime12Hours.monday.mondayOpenTime)
          : timings.Monday?.opening_time,

      monday_c:
        daysFlag.mondayflag === true
          ? ""
          : editFlag.editMondayCloseTime === true
          ? convertTime12To24(FormatedTime12Hours.monday.mondayCloseTime)
          : timings.Monday?.closing_time,

      tuesday_o:
        daysFlag.tuesdayflag === true
          ? ""
          : editFlag.editTuesdayOpenTime === true
          ? convertTime12To24(FormatedTime12Hours.tuesday.tuesdayOpenTime)
          : timings.Tuesday?.opening_time,

      tuesday_c:
        daysFlag.tuesdayflag === true
          ? ""
          : editFlag.editTuesdayCloseTime === true
          ? convertTime12To24(FormatedTime12Hours.tuesday.tuesdayCloseTime)
          : timings.Tuesday?.closing_time,

      wednesday_o:
        daysFlag.wednesdayflag === true
          ? ""
          : editFlag.editWednesdayOpenTime === true
          ? convertTime12To24(FormatedTime12Hours.wednesday.wednesdayOpenTime)
          : timings.Wednesday?.opening_time,

      wednesday_c:
        daysFlag.wednesdayflag === true
          ? ""
          : editFlag.editWednesdayCloseTime === true
          ? convertTime12To24(FormatedTime12Hours.wednesday.wednesdayCloseTime)
          : timings.Wednesday?.closing_time,

      thursday_o:
        daysFlag.thursdayflag === true
          ? ""
          : editFlag.editThursdayOpenTime === true
          ? convertTime12To24(FormatedTime12Hours.thursday.thursdayOpenTime)
          : timings.Thursday?.opening_time,

      thursday_c:
        daysFlag.thursdayflag === true
          ? ""
          : editFlag.editThursdayCloseTime === true
          ? convertTime12To24(FormatedTime12Hours.thursday.thursdayCloseTime)
          : timings.Thursday?.closing_time,

      friday_o:
        daysFlag.fridayflag === true
          ? ""
          : editFlag.editFridayOpenTime === true
          ? convertTime12To24(FormatedTime12Hours.friday.fridayOpenTime)
          : timings.Friday?.opening_time,

      friday_c:
        daysFlag.fridayflag === true
          ? ""
          : editFlag.editFridayCloseTime === true
          ? convertTime12To24(FormatedTime12Hours.friday.fridayCloseTime)
          : timings.Friday?.closing_time,

      saturday_o:
        daysFlag.saturdayflag === true
          ? ""
          : editFlag.editSaturdayOpenTime === true
          ? convertTime12To24(FormatedTime12Hours.saturday.saturdayOpenTime)
          : timings.Saturday?.opening_time,

      saturday_c:
        daysFlag.saturdayflag === true
          ? ""
          : editFlag.editSaturdayCloseTime === true
          ? convertTime12To24(FormatedTime12Hours.saturday.saturdayCloseTime)
          : timings.Saturday?.closing_time,

      sunday_o:
        daysFlag.sundayflag === true
          ? ""
          : editFlag.editSundayOpenTime === true
          ? convertTime12To24(FormatedTime12Hours.sunday.sundayOpenTime)
          : timings.Sunday?.opening_time,

      sunday_c:
        daysFlag.sundayflag === true
          ? ""
          : editFlag.editSundayCloseTime === true
          ? convertTime12To24(FormatedTime12Hours.sunday.sundayCloseTime)
          : timings.Sunday?.closing_time,

      bu_id: parseInt(Bu_id),
      api_method: "post",
    };

    // if (!UserData.store_name) {
    //   window.scrollTo(0, 400);
    //   setErr_Displayname("Store name cannot be empty");
    //   flag = true;
    // } else {
    //   setErr_Displayname("");
    // }

    // if (!UserData.st_website) {
    //   window.scrollTo(0, 400);
    //   setErr_Displayweb("Website cannot be empty!");
    //   flag = true;
    // } else {
    //   setErr_Displayweb("");
    // }

    // if (!UserData.store_description) {
    //   window.scrollTo(0, 1200);
    //   setErr_Displaydesc("Description cannot be empty!");
    //   flag = true;
    // } else {
    //   setErr_Displaydesc("");
    // }

    if (!cropImg) {
      window.scrollTo(0, 400);
      setErr_DisplayImg("Thumbnail image is required!");
      flag = true;
    } else {
      setErr_DisplayImg("");
    }

    if (!cropImgBanner) {
      window.scrollTo(0, 100);
      setErrBannerImg("Banner image is required!");
      flag = true;
    } else {
      setErrBannerImg("");
    }

    // if (edit === false) {
    const allDaysUnselected =
      daysFlag.sundayflag &&
      daysFlag.saturdayflag &&
      daysFlag.fridayflag &&
      daysFlag.thursdayflag &&
      daysFlag.wednesdayflag &&
      daysFlag.tuesdayflag &&
      daysFlag.mondayflag;

    if (allDaysUnselected && !isAppointment) {
      flag = true;
      window.scrollTo(0, 900);
      setErrTime(
        "Please select either Store Timings, Appointment Status, or both to proceed!"
      );
    } else {
      setErrTime("");

      // console.log(daysFlag.sundayflag);
      // console.log(convertTime12To24(FormatedTime12Hours.sunday.sundayOpenTime));
      // console.log(
      //   convertTime12To24(FormatedTime12Hours.sunday.sundayCloseTime)
      // );
      // console.log(
      //   editFlag.editSundayOpenTime === true
      //     ? convertTime12To24(FormatedTime12Hours.sunday.sundayOpenTime)
      //     : timings?.Sunday?.opening_time.substring(0, 5)
      // );
      // console.log(timings?.Sunday?.opening_time);
      // console.log(timings?.Sunday?.closing_time);

      if (!daysFlag.sundayflag) {
        const sundayOpeningTime = editFlag.editSundayOpenTime
          ? convertTime12To24(FormatedTime12Hours.sunday.sundayOpenTime)
          : timings?.Sunday?.opening_time?.substring(0, 5);

        const sundayClosingTime = editFlag.editSundayCloseTime
          ? convertTime12To24(FormatedTime12Hours.sunday.sundayCloseTime)
          : timings?.Sunday?.closing_time?.substring(0, 5);

        if (sundayOpeningTime === sundayClosingTime) {
          flag = true;
          window.scrollTo(0, 800);
          setErrDisplay((ps) => ({
            ...ps,
            sundayErr: "Opening hours cannot be same as closing hours!",
          }));
        } else {
          setErrDisplay((ps) => ({
            ...ps,
            sundayErr: "",
          }));
        }
      }

      if (!daysFlag.mondayflag) {
        const mondayOpeningTime = editFlag.editMondayOpenTime
          ? convertTime12To24(FormatedTime12Hours.monday.mondayOpenTime)
          : timings?.Monday?.opening_time?.substring(0, 5);

        const mondayClosingTime = editFlag.editMondayCloseTime
          ? convertTime12To24(FormatedTime12Hours.monday.mondayCloseTime)
          : timings?.Monday?.closing_time?.substring(0, 5);

        if (mondayOpeningTime === mondayClosingTime) {
          flag = true;
          window.scrollTo(0, 800);
          setErrDisplay((ps) => {
            return {
              ...ps,
              mondayErr: "Opening hours cannot be same as closing hours!",
            };
          });
        } else {
          setErrDisplay((ps) => {
            return {
              ...ps,
              mondayErr: "",
            };
          });
        }
      }

      if (!daysFlag.tuesdayflag) {
        const tuesdayOpeningTime = editFlag.editTuesdayOpenTime
          ? convertTime12To24(FormatedTime12Hours.tuesday.tuesdayOpenTime)
          : timings?.Tuesday?.opening_time?.substring(0, 5);

        const tuesdayClosingTime = editFlag.editTuesdayCloseTime
          ? convertTime12To24(FormatedTime12Hours.tuesday.tuesdayCloseTime)
          : timings?.Tuesday?.closing_time?.substring(0, 5);

        if (tuesdayOpeningTime === tuesdayClosingTime) {
          flag = true;
          window.scrollTo(0, 800);
          setErrDisplay((ps) => {
            return {
              ...ps,
              tuesdayErr: "Opening hours cannot be same as closing hours!",
            };
          });
        } else {
          setErrDisplay((ps) => {
            return {
              ...ps,
              tuesdayErr: "",
            };
          });
        }
      }

      if (!daysFlag.wednesdayflag) {
        const wednesdayOpeningTime = editFlag.editWednesdayOpenTime
          ? convertTime12To24(FormatedTime12Hours.wednesday.wednesdayOpenTime)
          : timings?.Wednesday?.opening_time?.substring(0, 5);

        const wednesdayClosingTime = editFlag.editWednesdayCloseTime
          ? convertTime12To24(FormatedTime12Hours.wednesday.wednesdayCloseTime)
          : timings?.Wednesday?.closing_time?.substring(0, 5);

        if (wednesdayOpeningTime === wednesdayClosingTime) {
          flag = true;
          window.scrollTo(0, 800);
          setErrDisplay((ps) => {
            return {
              ...ps,
              wednesdayErr: "Opening hours cannot be same as closing hours!",
            };
          });
        } else {
          setErrDisplay((ps) => {
            return {
              ...ps,
              wednesdayErr: "",
            };
          });
        }
      }

      if (!daysFlag.thursdayflag) {
        const thursdayOpeningTime = editFlag.editThursdayOpenTime
          ? convertTime12To24(FormatedTime12Hours.thursday.thursdayOpenTime)
          : timings?.Thursday?.opening_time?.substring(0, 5);

        const thursdayClosingTime = editFlag.editThursdayCloseTime
          ? convertTime12To24(FormatedTime12Hours.thursday.thursdayCloseTime)
          : timings?.Thursday?.closing_time?.substring(0, 5);

        if (thursdayOpeningTime === thursdayClosingTime) {
          flag = true;
          window.scrollTo(0, 800);
          setErrDisplay((ps) => {
            return {
              ...ps,
              thursdayErr: "Opening hours cannot be same as closing hours!",
            };
          });
        } else {
          setErrDisplay((ps) => {
            return {
              ...ps,
              thursdayErr: "",
            };
          });
        }
      }

      if (!daysFlag.fridayflag) {
        const fridayOpeningTime = editFlag.editFridayOpenTime
          ? convertTime12To24(FormatedTime12Hours.friday.fridayOpenTime)
          : timings?.Friday?.opening_time?.substring(0, 5);

        const fridayClosingTime = editFlag.editFridayCloseTime
          ? convertTime12To24(FormatedTime12Hours.friday.fridayCloseTime)
          : timings?.Friday?.closing_time?.substring(0, 5);

        if (fridayOpeningTime === fridayClosingTime) {
          flag = true;
          window.scrollTo(0, 800);
          setErrDisplay((ps) => {
            return {
              ...ps,
              fridayErr: "Opening hours cannot be same as closing hours!",
            };
          });
        } else {
          setErrDisplay((ps) => {
            return {
              ...ps,
              fridayErr: "",
            };
          });
        }
      }

      if (!daysFlag.saturdayflag) {
        const saturdayOpeningTime = editFlag.editSaturdayOpenTime
          ? convertTime12To24(FormatedTime12Hours.saturday.saturdayOpenTime)
          : timings?.Saturday?.opening_time?.substring(0, 5);

        const saturdayClosingTime = editFlag.editSaturdayCloseTime
          ? convertTime12To24(FormatedTime12Hours.saturday.saturdayCloseTime)
          : timings?.Saturday?.closing_time?.substring(0, 5);

        if (saturdayOpeningTime === saturdayClosingTime) {
          flag = true;
          window.scrollTo(0, 800);
          setErrDisplay((ps) => {
            return {
              ...ps,
              saturdayErr: "Opening hours cannot be same as closing hours!",
            };
          });
        } else {
          setErrDisplay((ps) => {
            return {
              ...ps,
              saturdayErr: "",
            };
          });
        }
      }
    }

    if (flag === false) {
      handleApi(data);
      // console.log(data)
    }
  };

  const handleApi = async (data) => {
    setLoading(true);
    const addStore = await StoreInfoAPI(data, () => {
      navigate("/");
    });
    if (addStore === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (addStore.success === true) {
        toast.success("Store Info Updated", {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setTimeout(() => {
          navigate(0).then(() => {
            getStoreInfo();
            dispatch(getUploadImageFlag(true));
            setThumbnailImageFlag(false);
            setbannerImageFlag(false);
            setStoreInfo(addStore);
            setEdit(false);
            setLoading(false);
            window.scrollTo(0, 0);
          });
        }, 1000);
      } else if (addStore.status === 429) {
        setLoading(true);
        toast.error(addStore.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.error(addStore.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getStoreInfo();
  }, []);

  // useEffect(()={

  // },[])

  // let x = 5; //minutes interval
  // let times = []; // time array
  // let tt = 0; // start time
  // let ap = ["AM", "PM"]; // AM-PM

  // //loop to increment the time and push results in array
  // for (let i = 0; tt < 24 * 60; i++) {
  //   var hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
  //   var mm = tt % 60; // getting minutes of the hour in 0-55 format
  //   times[i] =
  //     ("0" + (hh % 12)).slice(-2) +
  //     ":" +
  //     ("0" + mm).slice(-2) +
  //     " " +
  //     ap[Math.floor(hh / 12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
  //   tt = tt + x;
  // }

  // upload-banner-img
  const inputRef = useRef();
  const triggerFileSelectPopup = () => inputRef.current.click();

  const handleSetCropperImg = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const img = new window.Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      (async () => {
        const resizedImage = await resizeImage(
          img,
          constant.max_img_width,
          constant.max_img_height
        );
        setShow(true);
        setPrevimg(resizedImage);
      })();
    };
  };

  const clickHandler = (e) => {
    setIsAppointment(e.target.checked);
  };

  return (
    <>
      {loading === true ? <Loader /> : ""}
      <Row>
        <p>
          To make any changes, click on edit button, make the changes and click
          on save button.
        </p>
        <div className="text-right two-btns mr-5">
          {edit == true ? (
            <Button className="green-btn btn-margin" onClick={handleSubmit}>
              Save
            </Button>
          ) : (
            <Button className="green-btn btn-margin" onClick={EditHandler}>
              <MdEdit className="mb-1" />
              Edit
            </Button>
          )}
        </div>{" "}
        <Col md="12">
          <Form className="formmain mx-5 signin-row profile-form pb-2">
            <Row>
              <Col md="12" className="mb-4 banner-upload">
                <Form.Label className="form-label-custom">
                  <div className="label-info-text">
                    Store Banner Image
                    <span className="star-required">*</span>
                    <p className="info-text-space-f13">
                      &#40;Please upload banner image in dimension 1500 x 300
                      px&#41;
                    </p>
                    
                  </div>
                  <p className="label-info-text">You can update the store banner anytime. This is a default banner.</p>
                </Form.Label>

                {/* upload sec */}
                <div
                  className="upload_main_banner"
                  onClick={edit == true ? triggerFileSelectPopup : ""}
                  style={
                    edit == true ? { cursor: "pointer" } : { cursor: "no-drop" }
                  }
                >
                  <input
                    type="file"
                    accept="image/*"
                    ref={inputRef}
                    style={{ display: "none" }}
                    onChange={handleSetCropperImg}
                    onClick={(e) => (e.target.value = null)}
                  />
                  <div>
                    {cropImgBanner == "" ? (
                      <div className="upload_banner_empty">
                        <p className="info_bannerImg">
                          <img
                            loading="lazy"
                            src={DefaultImage}
                            className={
                              edit === true
                                ? "editDefaultImage"
                                : "DefaultImage"
                            }
                          />
                        </p>
                      </div>
                    ) : (
                      <img
                        loading="lazy"
                        src={cropImgBanner}
                        className="BannerImgStore"
                      />
                    )}
                  </div>
                </div>
                <ErrorLabel ErrorDisplay={errBannerImg} />
              </Col>

              {/* Modal-cropper for banner-img */}
              <Modal
                show={show}
                onHide={() => setShow(false)}
                style={{ marginTop: 0 }}
              >
                <Modal.Header></Modal.Header>
                <Modal.Body
                  style={{
                    width: "100%",
                    height: 350,
                    body: "none",
                  }}
                >
                  <div>
                    <Cropper
                      image={prevImg}
                      crop={crop}
                      rotation={rotation}
                      zoom={zoom}
                      aspect={5 / 1}
                      cropShape="rectangle"
                      showGrid={false}
                      onCropChange={setCrop}
                      onRotationChange={setRotation}
                      onCropComplete={onCropComplete}
                      onZoomChange={setZoom}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer className="modelFooter">
                  <div className="btn-footer">
                    <div className="btns">
                      <Button
                        onClick={() => {
                          setShow(false);
                          setbannerImageFlag(false);
                        }}
                        className="close_btn_cropper"
                      >
                        Close
                      </Button>
                    </div>
                    <div className="btns">
                      <Button
                        onClick={() => {
                          showCroppedImage();
                          setbannerImageFlag(true);
                        }}
                        className="green-btn mt-3 btn btn-primary"
                      >
                        Save Changes
                      </Button>
                    </div>
                  </div>
                </Modal.Footer>
              </Modal>

              {/* end */}

              <Row
                style={{ padding: "25px 12px 25px 0px" }}
                className="StoreThumbRow"
              >
                <Col md="3">
                  <Form.Label className="form-label-custom form-label mb-0">
                    <p className="StoreThumbnail">
                      <span>Store Thumbnail</span>
                      <p>
                        {" "}
                        Image<span className="star-required">*</span>
                        {["top"].map((placement) => (
                          <OverlayTrigger
                            // trigger={"click"}
                            key={placement}
                            placement={placement}
                            overlay={
                              <Tooltip
                                id={`tooltip-${placement}`}
                                style={{ width: "50%" }}
                              >
                                This thumbnail will appear in your profile pic
                                and on the market places that you will subscribe
                                to.
                                <b>
                                  ( Please upload store image in dimension of
                                  1:1 ratio. )
                                </b>
                              </Tooltip>
                            }
                          >
                            <Image
                              loading="lazy"
                              src={iicon}
                              className="mb-1"
                              width="15px"
                            ></Image>
                          </OverlayTrigger>
                        ))}
                      </p>
                    </p>
                  </Form.Label>
                  <UplaodImgWithCropper
                    cropImg={cropImg}
                    setcropImg={setcropImg}
                    iscropImgEdited={iscropImgEdited}
                    setIscropImgEdited={setIscropImgEdited}
                    setEdit={setEdit}
                    setThumbnailImageFlag={setThumbnailImageFlag}
                    edit={edit}
                  />
                  <ErrorLabel ErrorDisplay={err_DisplayImg} />
                </Col>

                <Col md="9" className="">
                  {/* <Form.Group className="mb-0" controlId="formBasicEmail">
                    <Form.Label className="form-label-custom">
                      Store Name <span className="star-required">*</span>
                    </Form.Label>

                    <InputGroup className="edit-border">
                      <Form.Control
                        type="text"
                        value={
                          edit === true
                            ? UserData.store_name
                            : locInfo.store_name
                        }
                        placeholder="Enter Store Name"
                        className="custom-formcontrol"
                        disabled={edit === true ? false : true}
                        onChange={handleChange}
                        maxLength={100}
                        name="store_name"
                      />
                    </InputGroup>
                    <ErrorLabel ErrorDisplay={err_Displayname} />
                  </Form.Group> */}

                  <Form.Group className="mb-0" controlId="formBasicEmail">
                    <Form.Label className="form-label-custom">
                      Website URL <span className="star-required"></span>
                    </Form.Label>

                    <InputGroup className="edit-border">
                      <Form.Control
                        type="text"
                        value={
                          edit === true
                            ? UserData.st_website
                            : locInfo.business_url
                        }
                        placeholder="Enter Website URL"
                        className="custom-formcontrol"
                        onChange={handleChange}
                        name="st_website"
                        disabled={edit === true ? false : true}
                        autoComplete="off"
                      />
                    </InputGroup>
                    <ErrorLabel ErrorDisplay={err_Displayweb} />
                  </Form.Group>
                </Col>
              </Row>

              <Col md="12" className="store_Timings_Col">
                <h1 className="page-maintitle d-flex justify-content-center orange-text">
                  Store Timings <span className="star-required">*</span>
                </h1>
                <div className="store-timing-text">
                  <p className="info-text-space-f13 text-center">
                    &#40;You can choose Store Timings or By Appointment only
                    function to satisfy the requirement for this section.
                    However you can choose both options if applicable for your
                    business.&#41;
                  </p>
                </div>

                {/* ///////////////////////////////// label /////////////////////////////////////////////////////// */}
                <div className="switch-sec time_Label">
                  <div className="openingDaysDiv">
                    <h3>Days</h3>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label={daysFlag.sundayflag === false ? "Open" : "Closed"}
                      disabled={edit === true ? false : true}
                      onChange={handleSwitchSunday}
                      checked={daysFlag.sundayflag} //true= closed, false= open
                    />
                  </div>
                  <>
                    <div className="openingHoursDiv">
                      <h3>
                        Opening Hours
                        <br />
                        (HH/MM)
                      </h3>
                      <select
                        aria-label="Default select example"
                        disabled={edit === true ? false : true}
                        onChange={(e) => {
                          onSunday("hrs", e);
                        }}
                        value={
                          editHrsFlag.editSundayHrsOpentime === true
                            ? hrsInput.sundayOpenhrs
                            : FormatedTime24Hours.sundayOpenTime.hrs
                        }
                      >
                        {/* <option>Hrs</option> */}
                        {hours.map((data) => {
                          return <option value={data}>{data}</option>;
                        })}
                      </select>
                      <div style={{ padding: "0 0.3rem" }}>:</div>
                      <select
                        aria-label="Default select example"
                        disabled={edit === true ? false : true}
                        onChange={(e) => {
                          onSunday("mins", e);
                        }}
                        value={
                          editFlag.editSundayOpenTime === true
                            ? minsInput.sundayOpenMins
                            : FormatedTime24Hours.sundayOpenTime.mins
                        }
                      >
                        {/* <option>Mins</option> */}
                        {minutes.map((data) => {
                          return <option value={data}>{data}</option>;
                        })}
                      </select>
                      <div style={{ padding: "0.2rem" }}></div>
                      <select
                        aria-label="Default select example"
                        disabled={edit === true ? false : true}
                        onChange={(e) => {
                          onSunday("ampm", e);
                        }}
                        value={
                          editFlag.editSundayOpenTime === true
                            ? amPmInput.sundayOpenAmPm
                            : FormatedTime24Hours.sundayOpenTime.ampm
                        }
                      >
                        <option value="am">AM</option>
                        <option value="pm">PM</option>
                      </select>
                    </div>

                    <div style={{ visibility: "hidden" }}>-</div>

                    <div className="openingHoursDiv">
                      <h3>
                        Closing Hours
                        <br />
                        (HH/MM)
                      </h3>
                      <select
                        aria-label="Default select example"
                        disabled={edit === true ? false : true}
                        onChange={(e) => {
                          offSunday("hrs", e);
                        }}
                        value={
                          editHrsFlag.editSundayHrsClosetime === true
                            ? hrsInput.sundayClosehrs
                            : FormatedTime24Hours.sundayCloseTime.hrs
                        }
                      >
                        {/* <option>Hrs</option> */}
                        {hours.map((data) => {
                          return <option value={data}>{data}</option>;
                        })}
                      </select>
                      <div style={{ padding: "0 0.3rem" }}>:</div>
                      <select
                        aria-label="Default select example"
                        disabled={edit === true ? false : true}
                        onChange={(e) => {
                          offSunday("mins", e);
                        }}
                        value={
                          editFlag.editSundayCloseTime === true
                            ? minsInput.sundayCloseMins
                            : FormatedTime24Hours.sundayCloseTime.mins
                        }
                      >
                        {/* <option>Mins</option> */}
                        {minutes.map((data) => {
                          return <option value={data}>{data}</option>;
                        })}
                      </select>
                      <div style={{ padding: "0.2rem" }}></div>
                      <select
                        aria-label="Default select example"
                        disabled={edit === true ? false : true}
                        onChange={(e) => {
                          offSunday("ampm", e);
                        }}
                        value={
                          editFlag.editSundayCloseTime === true
                            ? amPmInput.sundayCloseAmPm
                            : FormatedTime24Hours.sundayCloseTime.ampm
                        }
                      >
                        <option value="am">AM</option>
                        <option value="pm">PM</option>
                      </select>
                    </div>
                  </>
                </div>

                {/* ///////////////////////////////// Sunday /////////////////////////////////////////////////////// */}

                <div className="switch-sec-main">
                  <div className="switch-sec">
                    <div className="date-switch">Sunday</div>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label={daysFlag.sundayflag === false ? "Open" : "Closed"}
                      disabled={edit === true ? false : true}
                      onChange={handleSwitchSunday}
                      checked={daysFlag.sundayflag} //true= closed, false= open
                    />
                    {daysFlag.sundayflag === false ? (
                      <>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onSunday("hrs", e);
                          }}
                          value={
                            editHrsFlag.editSundayHrsOpentime === true
                              ? hrsInput.sundayOpenhrs
                              : FormatedTime24Hours.sundayOpenTime.hrs
                          }
                        >
                          {/* <option>Hrs</option> */}
                          {hours.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0 0.3rem" }}>:</div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onSunday("mins", e);
                          }}
                          value={
                            editMinsFlag.editSundayMinsOpentime === true
                              ? minsInput.sundayOpenMins
                              : FormatedTime24Hours.sundayOpenTime.mins
                          }
                        >
                          {/* <option>Mins</option> */}
                          {minutes.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0.2rem" }}></div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onSunday("ampm", e);
                          }}
                          value={
                            editAmPmFlag.editSundayAmPmOpentime === true
                              ? amPmInput.sundayOpenAmPm
                              : FormatedTime24Hours.sundayOpenTime.ampm
                          }
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>

                        <div style={{ padding: "0 0.3rem" }}>-</div>

                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offSunday("hrs", e);
                          }}
                          value={
                            editHrsFlag.editSundayHrsClosetime === true
                              ? hrsInput.sundayClosehrs
                              : FormatedTime24Hours.sundayCloseTime.hrs
                          }
                        >
                          {/* <option>Hrs</option> */}
                          {hours.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0 0.3rem" }}>:</div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offSunday("mins", e);
                          }}
                          value={
                            editMinsFlag.editSundayMinsClosetime === true
                              ? minsInput.sundayCloseMins
                              : FormatedTime24Hours.sundayCloseTime.mins
                          }
                        >
                          {/* <option>Mins</option> */}
                          {minutes.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0.2rem" }}></div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offSunday("ampm", e);
                          }}
                          value={
                            editAmPmFlag.editSundayAmPmClosetime === true
                              ? amPmInput.sundayCloseAmPm
                              : FormatedTime24Hours.sundayCloseTime.ampm
                          }
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="store_Time_Error">
                    <ErrorLabel ErrorDisplay={errdisplay.sundayErr} />
                  </div>
                </div>

                {/* //////////////////////////////////////////////////////////////////////////////////////////////// */}

                {/* ///////////////////////////////////// Monday /////////////////////////////////////////////////// */}

                <div className="switch-sec-main pt-2">
                  <div className="switch-sec">
                    <div className="date-switch">Monday</div>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label={daysFlag.mondayflag === false ? "Open" : "Closed"}
                      disabled={edit === true ? false : true}
                      onChange={handleSwitchMonday}
                      checked={daysFlag.mondayflag} //true= closed, false= open
                    />
                    {daysFlag.mondayflag === false ? (
                      <>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onMonday("hrs", e);
                          }}
                          value={
                            editHrsFlag.editMondayHrsOpentime === true
                              ? hrsInput.mondayOpenhrs
                              : FormatedTime24Hours.mondayOpenTime.hrs
                          }
                        >
                          {/* <option>Hrs</option> */}
                          {hours.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0 0.3rem" }}>:</div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onMonday("mins", e);
                          }}
                          value={
                            editMinsFlag.editMondayMinsOpentime === true
                              ? minsInput.mondayOpenMins
                              : FormatedTime24Hours.mondayOpenTime.mins
                          }
                        >
                          {/* <option>Mins</option> */}
                          {minutes.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0.2rem" }}></div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onMonday("ampm", e);
                          }}
                          value={
                            editAmPmFlag.editMondayAmPmOpentime === true
                              ? amPmInput.mondayOpenAmPm
                              : FormatedTime24Hours.mondayOpenTime.ampm
                          }
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>

                        <div style={{ padding: "0 0.3rem" }}>-</div>

                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offMonday("hrs", e);
                          }}
                          value={
                            editHrsFlag.editMondayHrsClosetime === true
                              ? hrsInput.mondayClosehrs
                              : FormatedTime24Hours.mondayCloseTime.hrs
                          }
                        >
                          {/* <option>Hrs</option> */}
                          {hours.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0 0.3rem" }}>:</div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offMonday("mins", e);
                          }}
                          value={
                            editMinsFlag.editMondayMinsClosetime === true
                              ? minsInput.mondayCloseMins
                              : FormatedTime24Hours.mondayCloseTime.mins
                          }
                        >
                          {/* <option>Mins</option> */}
                          {minutes.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0.2rem" }}></div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offMonday("ampm", e);
                          }}
                          value={
                            editAmPmFlag.editMondayAmPmClosetime === true
                              ? amPmInput.mondayCloseAmPm
                              : FormatedTime24Hours.mondayCloseTime.ampm
                          }
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="store_Time_Error">
                    <ErrorLabel ErrorDisplay={errdisplay.mondayErr} />
                  </div>
                </div>

                {/* /////////////////////////////////////////////////////////////////////////////////////////////// */}

                {/* ///////////////////////////////////// Tuesday /////////////////////////////////////////////////// */}

                <div className="switch-sec-main pt-2">
                  <div className="switch-sec">
                    <div className="date-switch">Tuesday</div>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label={daysFlag.tuesdayflag === false ? "Open" : "Closed"}
                      disabled={edit === true ? false : true}
                      onChange={handleSwitchTuesday}
                      checked={daysFlag.tuesdayflag} //true= closed, false= open
                    />
                    {daysFlag.tuesdayflag === false ? (
                      <>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onTuesday("hrs", e);
                          }}
                          value={
                            editHrsFlag.editTuesdayHrsOpentime === true
                              ? hrsInput.tuesdayOpenhrs
                              : FormatedTime24Hours.tuesdayOpenTime.hrs
                          }
                        >
                          {/* <option>Hrs</option> */}
                          {hours.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0 0.3rem" }}>:</div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onTuesday("mins", e);
                          }}
                          value={
                            editMinsFlag.editTuesdayMinsOpentime === true
                              ? minsInput.tuesdayOpenMins
                              : FormatedTime24Hours.tuesdayOpenTime.mins
                          }
                        >
                          {/* <option>Mins</option> */}
                          {minutes.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0.2rem" }}></div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onTuesday("ampm", e);
                          }}
                          value={
                            editAmPmFlag.editTuesdayAmPmOpentime === true
                              ? amPmInput.tuesdayOpenAmPm
                              : FormatedTime24Hours.tuesdayOpenTime.ampm
                          }
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>

                        <div style={{ padding: "0 0.3rem" }}>-</div>

                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offTuesday("hrs", e);
                          }}
                          value={
                            editHrsFlag.editTuesdayHrsClosetime === true
                              ? hrsInput.tuesdayClosehrs
                              : FormatedTime24Hours.tuesdayCloseTime.hrs
                          }
                        >
                          {/* <option>Hrs</option> */}
                          {hours.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0 0.3rem" }}>:</div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offTuesday("mins", e);
                          }}
                          value={
                            editMinsFlag.editTuesdayMinsClosetime === true
                              ? minsInput.tuesdayCloseMins
                              : FormatedTime24Hours.tuesdayCloseTime.mins
                          }
                        >
                          {/* <option>Mins</option> */}
                          {minutes.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0.2rem" }}></div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offTuesday("ampm", e);
                          }}
                          value={
                            editAmPmFlag.editTuesdayAmPmClosetime === true
                              ? amPmInput.tuesdayCloseAmPm
                              : FormatedTime24Hours.tuesdayCloseTime.ampm
                          }
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="store_Time_Error">
                    <ErrorLabel ErrorDisplay={errdisplay.tuesdayErr} />
                  </div>
                </div>

                {/* /////////////////////////////////////////////////////////////////////////////////////////////// */}

                {/* ///////////////////////////////////// wednesday /////////////////////////////////////////////////// */}

                <div className="switch-sec-main pt-2">
                  <div className="switch-sec">
                    <div className="date-switch">Wednesday</div>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label={
                        daysFlag.wednesdayflag === false ? "Open" : "Closed"
                      }
                      disabled={edit === true ? false : true}
                      onChange={handleSwitchWednesday}
                      checked={daysFlag.wednesdayflag} //true= closed, false= open
                    />
                    {daysFlag.wednesdayflag === false ? (
                      <>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onWednesday("hrs", e);
                          }}
                          value={
                            editHrsFlag.editWednesdayHrsOpentime === true
                              ? hrsInput.wednesdayOpenhrs
                              : FormatedTime24Hours.wednesdayOpenTime.hrs
                          }
                        >
                          {/* <option>Hrs</option> */}
                          {hours.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0 0.3rem" }}>:</div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onWednesday("mins", e);
                          }}
                          value={
                            editMinsFlag.editWednesdayMinsOpentime === true
                              ? minsInput.wednesdayOpenMins
                              : FormatedTime24Hours.wednesdayOpenTime.mins
                          }
                        >
                          {/* <option>Mins</option> */}
                          {minutes.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0.2rem" }}></div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onWednesday("ampm", e);
                          }}
                          value={
                            editAmPmFlag.editWednesdayAmPmOpentime === true
                              ? amPmInput.wednesdayOpenAmPm
                              : FormatedTime24Hours.wednesdayOpenTime.ampm
                          }
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>

                        <div style={{ padding: "0 0.3rem" }}>-</div>

                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offWednesday("hrs", e);
                          }}
                          value={
                            editHrsFlag.editWednesdayHrsClosetime === true
                              ? hrsInput.wednesdayClosehrs
                              : FormatedTime24Hours.wednesdayCloseTime.hrs
                          }
                        >
                          {/* <option>Hrs</option> */}
                          {hours.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0 0.3rem" }}>:</div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offWednesday("mins", e);
                          }}
                          value={
                            editMinsFlag.editWednesdayMinsClosetime === true
                              ? minsInput.wednesdayCloseMins
                              : FormatedTime24Hours.wednesdayCloseTime.mins
                          }
                        >
                          {/* <option>Mins</option> */}
                          {minutes.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0.2rem" }}></div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offWednesday("ampm", e);
                          }}
                          value={
                            editAmPmFlag.editWednesdayAmPmClosetime === true
                              ? amPmInput.wednesdayCloseAmPm
                              : FormatedTime24Hours.wednesdayCloseTime.ampm
                          }
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="store_Time_Error">
                    <ErrorLabel ErrorDisplay={errdisplay.wednesdayErr} />
                  </div>
                </div>

                {/* /////////////////////////////////////////////////////////////////////////////////////////////// */}

                {/* ///////////////////////////////////// Thursday /////////////////////////////////////////////////// */}

                <div className="switch-sec-main pt-2">
                  <div className="switch-sec">
                    <div className="date-switch">Thursday</div>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label={
                        daysFlag.thursdayflag === false ? "Open" : "Closed"
                      }
                      disabled={edit === true ? false : true}
                      onChange={handleSwitchThursday}
                      checked={daysFlag.thursdayflag} //true= closed, false= open
                    />
                    {daysFlag.thursdayflag === false ? (
                      <>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onThursday("hrs", e);
                          }}
                          value={
                            editHrsFlag.editThursdayHrsOpentime === true
                              ? hrsInput.thursdayOpenhrs
                              : FormatedTime24Hours.thursdayOpenTime.hrs
                          }
                        >
                          {/* <option>Hrs</option> */}
                          {hours.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0 0.3rem" }}>:</div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onThursday("mins", e);
                          }}
                          value={
                            editMinsFlag.editThursdayMinsOpentime === true
                              ? minsInput.thursdayOpenMins
                              : FormatedTime24Hours.thursdayOpenTime.mins
                          }
                        >
                          {/* <option>Mins</option> */}
                          {minutes.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0.2rem" }}></div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onThursday("ampm", e);
                          }}
                          value={
                            editAmPmFlag.editThursdayAmPmOpentime === true
                              ? amPmInput.thursdayOpenAmPm
                              : FormatedTime24Hours.thursdayOpenTime.ampm
                          }
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>

                        <div style={{ padding: "0 0.3rem" }}>-</div>

                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offThursday("hrs", e);
                          }}
                          value={
                            editHrsFlag.editThursdayHrsClosetime === true
                              ? hrsInput.thursdayClosehrs
                              : FormatedTime24Hours.thursdayCloseTime.hrs
                          }
                        >
                          {/* <option>Hrs</option> */}
                          {hours.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0 0.3rem" }}>:</div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offThursday("mins", e);
                          }}
                          value={
                            editMinsFlag.editThursdayMinsClosetime === true
                              ? minsInput.thursdayCloseMins
                              : FormatedTime24Hours.thursdayCloseTime.mins
                          }
                        >
                          {/* <option>Mins</option> */}
                          {minutes.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0.2rem" }}></div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offThursday("ampm", e);
                          }}
                          value={
                            editAmPmFlag.editThursdayAmPmClosetime === true
                              ? amPmInput.thursdayCloseAmPm
                              : FormatedTime24Hours.thursdayCloseTime.ampm
                          }
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="store_Time_Error">
                    <ErrorLabel ErrorDisplay={errdisplay.thursdayErr} />
                  </div>
                </div>

                {/* /////////////////////////////////////////////////////////////////////////////////////////////// */}

                {/* ///////////////////////////////////// Friday /////////////////////////////////////////////////// */}

                <div className="switch-sec-main pt-2">
                  <div className="switch-sec">
                    <div className="date-switch">Friday</div>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label={daysFlag.fridayflag === false ? "Open" : "Closed"}
                      disabled={edit === true ? false : true}
                      onChange={handleSwitchFriday}
                      checked={daysFlag.fridayflag} //true= closed, false= open
                    />
                    {daysFlag.fridayflag === false ? (
                      <>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onFriday("hrs", e);
                          }}
                          value={
                            editHrsFlag.editFridayHrsOpentime === true
                              ? hrsInput.fridayOpenhrs
                              : FormatedTime24Hours.fridayOpenTime.hrs
                          }
                        >
                          {/* <option>Hrs</option> */}
                          {hours.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0 0.3rem" }}>:</div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onFriday("mins", e);
                          }}
                          value={
                            editMinsFlag.editFridayMinsOpentime === true
                              ? minsInput.fridayOpenMins
                              : FormatedTime24Hours.fridayOpenTime.mins
                          }
                        >
                          {/* <option>Mins</option> */}
                          {minutes.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0.2rem" }}></div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onFriday("ampm", e);
                          }}
                          value={
                            editAmPmFlag.editFridayAmPmOpentime === true
                              ? amPmInput.fridayOpenAmPm
                              : FormatedTime24Hours.fridayOpenTime.ampm
                          }
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>

                        <div style={{ padding: "0 0.3rem" }}>-</div>

                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offFriday("hrs", e);
                          }}
                          value={
                            editHrsFlag.editFridayHrsClosetime === true
                              ? hrsInput.fridayClosehrs
                              : FormatedTime24Hours.fridayCloseTime.hrs
                          }
                        >
                          {/* <option>Hrs</option> */}
                          {hours.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0 0.3rem" }}>:</div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offFriday("mins", e);
                          }}
                          value={
                            editMinsFlag.editFridayMinsClosetime === true
                              ? minsInput.fridayCloseMins
                              : FormatedTime24Hours.fridayCloseTime.mins
                          }
                        >
                          {/* <option>Mins</option> */}
                          {minutes.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0.2rem" }}></div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offFriday("ampm", e);
                          }}
                          value={
                            editAmPmFlag.editFridayAmPmClosetime === true
                              ? amPmInput.fridayCloseAmPm
                              : FormatedTime24Hours.fridayCloseTime.ampm
                          }
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="store_Time_Error">
                    <ErrorLabel ErrorDisplay={errdisplay.fridayErr} />
                  </div>
                </div>

                {/* /////////////////////////////////////////////////////////////////////////////////////////////// */}

                {/* ///////////////////////////////////// Saturday /////////////////////////////////////////////////// */}

                <div className="switch-sec-main pt-2">
                  <div className="switch-sec">
                    <div className="date-switch">Saturday</div>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label={
                        daysFlag.saturdayflag === false ? "Open" : "Closed"
                      }
                      disabled={edit === true ? false : true}
                      onChange={handleSwitchSaturday}
                      checked={daysFlag.saturdayflag} //true= closed, false= open
                    />
                    {daysFlag.saturdayflag === false ? (
                      <>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onSaturday("hrs", e);
                          }}
                          value={
                            editHrsFlag?.editSaturdayHrsOpentime === true
                              ? hrsInput.saturdayOpenhrs
                              : FormatedTime24Hours?.saturdayOpenTime?.hrs
                          }
                        >
                          {/* <option>Hrs</option> */}
                          {hours.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0 0.3rem" }}>:</div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onSaturday("mins", e);
                          }}
                          value={
                            editMinsFlag.editSaturdayMinsOpentime === true
                              ? minsInput.saturdayOpenMins
                              : FormatedTime24Hours.saturdayOpenTime.mins
                          }
                        >
                          {/* <option>Mins</option> */}
                          {minutes.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0.2rem" }}></div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            onSaturday("ampm", e);
                          }}
                          value={
                            editAmPmFlag.editSaturdayAmPmOpentime === true
                              ? amPmInput.saturdayOpenAmPm
                              : FormatedTime24Hours.saturdayOpenTime.ampm
                          }
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>

                        <div style={{ padding: "0 0.3rem" }}>-</div>

                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offSaturday("hrs", e);
                          }}
                          value={
                            editHrsFlag.editSaturdayHrsClosetime === true
                              ? hrsInput.saturdayClosehrs
                              : FormatedTime24Hours.saturdayCloseTime.hrs
                          }
                        >
                          {/* <option>Hrs</option> */}
                          {hours.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0 0.3rem" }}>:</div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offSaturday("mins", e);
                          }}
                          value={
                            editMinsFlag.editSaturdayMinsClosetime === true
                              ? minsInput.saturdayCloseMins
                              : FormatedTime24Hours.saturdayCloseTime.mins
                          }
                        >
                          {/* <option>Mins</option> */}
                          {minutes.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}
                        </select>
                        <div style={{ padding: "0.2rem" }}></div>
                        <select
                          aria-label="Default select example"
                          disabled={edit === true ? false : true}
                          onChange={(e) => {
                            offSaturday("ampm", e);
                          }}
                          value={
                            editAmPmFlag.editSaturdayAmPmClosetime === true
                              ? amPmInput.saturdayCloseAmPm
                              : FormatedTime24Hours.saturdayCloseTime.ampm
                          }
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="store_Time_Error">
                    <ErrorLabel ErrorDisplay={errdisplay.saturdayErr} />
                  </div>
                </div>
                <div
                  className="flex items-start gap-1 checkbox-div"
                  style={{ marginBottom: 10 }}
                >
                  <input
                    type="checkbox"
                    disabled={!edit}
                    onChange={(e) => clickHandler(e)}
                    checked={isAppointment}
                    style={{
                      marginTop: "4px",
                      cursor: edit ? "pointer" : "default",
                    }}
                    // sx={{
                    //   "&.Mui-checked": {
                    //     color: !edit ? "#cfcfcf" : "#e66100",
                    //   },
                    // }}
                  />
                  <div className="flex-col">
                    By Appointment Only.
                    <span className="text-sm">
                      Check this if you only see clients by appointment only.
                    </span>
                  </div>
                </div>
                <ErrorLabel ErrorDisplay={errTime} />
                {/* /////////////////////////////////////////////////////////////////////////////////////////////// */}
              </Col>
              {/* <Col md="12" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom mb-2">
                    Store Description <span className="star-required">*</span>
                  </Form.Label>
                  <Form.Group
                    className="mb-0"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Control
                      as="textarea"
                      rows={10}
                      maxLength={1000}
                      name="store_description"
                      value={
                        edit === true
                          ? UserData.store_description
                          : locInfo.store_description
                      }
                      onChange={handleChange}
                      disabled={edit === true ? false : true}
                    />
                  </Form.Group>
                </Form.Group>
                <ErrorLabel ErrorDisplay={err_Displaydesc} />
              </Col> */}
            </Row>
          </Form>
          <Row>
            {edit === true && (
              <div className="text-center small-btns d-flex">
                <Link onClick={CancelHandler}>
                  <p className="view">Cancel</p>
                </Link>
                <Button
                  variant="primary"
                  type="submit"
                  className="green-btn mt-3"
                  onClick={handleSubmit}
                >
                  Save
                </Button>
              </div>
            )}
          </Row>
          <Col md="12">
            <AddStoreLocation />
          </Col>
        </Col>
      </Row>
    </>
  );
};

export default EditNewLocationNew;
